import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const GoogleCallbackPage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { login } = useAuth();

    useEffect(() => {
        const token = searchParams.get('token');
        const refreshToken = searchParams.get('refreshToken');
        const error = searchParams.get('error');

        if (token && refreshToken) {
            // ✅ VERIFICAR TOKEN E FAZER LOGIN
            fetch('/api/auth/verify', {
                headers: { Authorization: `Bearer ${token}` }
            })
                .then(res => res.json())
                .then(data => {
                    // ✅ PASSAR 3 ARGUMENTOS
                    login(token, refreshToken, {
                        userId: data.userId,
                        username: data.username,
                        email: data.email,
                        role: data.role
                    });
                    navigate('/dashboard');
                })
                .catch(() => navigate('/login?error=invalid_token'));
        } else {
            navigate('/login?error=' + (error || 'unknown'));
        }
    }, [searchParams, navigate, login]);

    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            fontFamily: 'Inter, sans-serif'
        }}>
            <p>Autenticando com Google...</p>
        </div>
    );
};

export default GoogleCallbackPage;